import { api } from '@marketplace-web/core-api/core-api-client-data'

import { GetReferrerResp } from '../types/referrer'

export const getReferrer = () => api.get<GetReferrerResp>('/referrals/referrer')
